import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { getPlans } from '../services/Plans';
import { Helmet } from 'react-helmet-async';

const FreeTrial = () => {
    const [standardPlan, setStandardPlan] = useState<any>(null);
    const navigate = useNavigate();

    useEffect(() => {
        getPlans()
            .then((data: any) => {
                const standard = data.filter((plan: any) => plan.planName.includes("Standard"));
                standard.sort((a: any, b: any) => a.billingCycle.localeCompare(b.billingCycle));
                setStandardPlan(standard[0]);
            })
            .catch(error => console.error('Error fetching plans data:', error));
    }, []);

    const handleCheckout = () => {
        if (standardPlan) {
            navigate("/checkout", {
                state: {
                    planId: standardPlan.id,
                    planName: standardPlan.planName,
                    price: 0,
                    billingCycle: 'month',
                    source: 'free-trial'
                }
            });
        } else {
            console.error("Standard plan is not available.");
        }
    };

    return (
        <>
            <Helmet>
                <title>My Church Directory Free Trial | Online Church Directory Software</title>

                <meta
                    name="description"
                    content="Explore powerful church directory features including member management, mobile apps, email and text messaging, printable directories, and secure online access. Manage your church directory with ease."
                />
            </Helmet>

            {/* Hero */}
            <section className="bg-slate-50">
                <div className="max-w-7xl mx-auto px-6 py-20 grid lg:grid-cols-2 gap-12 items-center">

                    <div>
                        <span className="inline-flex rounded-full bg-sky-100 text-secondary px-4 py-1 text-sm font-medium">
                            30-Day Free Trial
                        </span>

                        <h1 className="different_heading mt-5 text-4xl lg:text-5xl font-bold text-slate-900">
                            Try My Church Directory
                            <br />
                            Free for 30 Days
                        </h1>

                        <p className="mt-6 text-lg text-slate-600 leading-8">
                            Experience all the essential tools to manage members, ministries,
                            events, communication, and leadership—completely free with no
                            obligation.
                        </p>


                    </div>

                    <div>
                        <img
                            src="../images/free-trial-mycdir.png"
                            alt="Free Trial"
                            className="rounded-3xl shadow-xl w-full"
                        />
                    </div>

                </div>
            </section>

            {/* Membership Card */}

            <section className="py-20 bg-white">
                <div className="max-w-xl mx-auto px-6">

                    <div className="rounded-3xl border border-slate-200 shadow-lg overflow-hidden">

                        <div className="bg-sky-600 text-white text-center py-5">
                            <h2 className="different_heading text-2xl font-bold">
                                Standard Membership
                            </h2>

                            <p className="mt-2 text-sky-100">
                                Everything you need to get started
                            </p>
                        </div>

                        <div className="p-8">

                            <ul className="space-y-5 text-slate-700">

                                <li className="flex gap-3">
                                    <span className="text-green-600 font-bold">✓</span>
                                    Manage member profiles and family information.
                                </li>

                                <li className="flex gap-3">
                                    <span className="text-green-600 font-bold">✓</span>
                                    Organize ministries, events, and volunteers.
                                </li>

                                <li className="flex gap-3">
                                    <span className="text-green-600 font-bold">✓</span>
                                    Access member communication tools.
                                </li>

                                <li className="flex gap-3">
                                    <span className="text-green-600 font-bold">✓</span>
                                    Enjoy the complete platform free for 30 days.
                                </li>

                            </ul>

                            <button
                                onClick={handleCheckout}
                                className="mt-10 w-full rounded-xl bg-sky-600 py-4 text-white font-semibold hover:bg-sky-700 transition"
                            >
                                Start Free Trial
                            </button>

                        </div>

                    </div>

                </div>
            </section>

            {/* Benefits */}

            <section className="bg-slate-50 py-20">
                <div className="max-w-6xl mx-auto px-6">

                    <div className="text-center mb-14">
                        <h2 className="different_heading text-3xl font-bold">
                            Why Start a Free Trial?
                        </h2>

                        <p className="mt-3 text-slate-600">
                            Experience everything before choosing a plan.
                        </p>
                    </div>

                    <div className="grid md:grid-cols-3 gap-6">

                        <div className="rounded-2xl bg-white border p-6 text-center">
                            <h3 className="font-semibold text-lg mb-3">
                                Full Access
                            </h3>

                            <p className="text-slate-600">
                                Explore all core features without limitations.
                            </p>
                        </div>

                        <div className="rounded-2xl bg-white border p-6 text-center">
                            <h3 className="font-semibold text-lg mb-3">
                                No Commitment
                            </h3>

                            <p className="text-slate-600">
                                Cancel anytime during the trial period.
                            </p>
                        </div>

                        <div className="rounded-2xl bg-white border p-6 text-center">
                            <h3 className="font-semibold text-lg mb-3">
                                Quick Setup
                            </h3>

                            <p className="text-slate-600">
                                Get your church directory running in minutes.
                            </p>
                        </div>

                    </div>

                </div>
            </section>
        </>
    );
};

export default FreeTrial;